import { render, staticRenderFns } from "./AnnotationList.vue?vue&type=template&id=138cef8c&scoped=true"
import script from "./AnnotationList.vue?vue&type=script&lang=js"
export * from "./AnnotationList.vue?vue&type=script&lang=js"
import style0 from "./AnnotationList.vue?vue&type=style&index=0&id=138cef8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cef8c",
  null
  
)

export default component.exports